import { sortBy } from 'lodash'

import { ScheduledCourse } from '../../models/LearningItem'
import { User } from '../../models/User'

export default function scheduledCourseParticipants(learningItem: ScheduledCourse) {
  const participants: {
    [userUuid: string]: { participant: User; events: ScheduledCourse['scheduledCourse']['events'] }
  } = {}

  for (const event of learningItem.scheduledCourse.events) {
    for (const participant of event.participants) {
      participants[participant.uuid] = participants[participant.uuid] || { participant, events: [] }
      participants[participant.uuid].events.push(event)
    }
  }

  return sortBy(Object.values(participants), ({ participant }) => `${participant.lastname} ${participant.firstname}`)
}
